import { NextImage } from 'src/components/shared/elements/NextImage';
import { CLOUD_FRONT_IMAGE_PATH } from 'src/constants/imagePath';

type Props = {
  footerImageList: {
    path: string;
    width: number;
    height: number;
  }[];
};

export const ImageList: React.FC<Props> = ({ footerImageList }) => (
  <ul className="flex flex-wrap justify-center gap-2 sm:gap-6 semiLg:gap-2 py-5">
    {footerImageList.map((image) => (
      <li key={image.path}>
        <NextImage src={`${CLOUD_FRONT_IMAGE_PATH}${image.path}`} width={image.width} height={image.height} alt="" />
      </li>
    ))}
  </ul>
);
